<app-loader *ngIf="loading"></app-loader>
<div class="row">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'" [lastLinkColor]="'rgba(196, 196, 205, 0.42)'"
      [fontColor]="'#c4c4cd'">
    </app-dynamic-breadcrumb>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="row header">Consolidated Screen Details</div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <form #queryEngineForm="ngForm">
      <div class="row form-row">
        <div class="col-1"><label>Screen Type </label></div>
        <div class="col-2">
          <select id="screenType" name="screenType" [(ngModel)]="screenType"
            class="query-engine-form-control w-100 select-arrow" (change)="onScreenTypeChange()">
            <option [ngValue]="null">Select</option>
            <ng-container *appPermission="['I', null, null, 'ingestion']">
              <option [ngValue]="0">Ingestion Edit</option>
            </ng-container>
            <ng-container *appPermission="['I', null, null, 'administration']">
              <option [ngValue]="1">SSC Configuration</option>
            </ng-container>
            <ng-container *appPermission="['I', null, null, 'support']">
              <option [ngValue]="2">Ref Data Changes</option>
            </ng-container>
          </select>

        </div>
      </div>
<br/>
      <div class="row form-row" *ngIf="screenType == 0">
        <div class="col-12">
          <app-ingestion-list-filter
            [selectedIngestion]="selectedIngestion"
            [IngestionList]="ingestionList"
            (selectedIngestionChange)="onIngestionSelected($event)">
          </app-ingestion-list-filter>
        </div>
      </div>

      <div class="row form-row" *ngIf="screenType == 1">
        <div class="col-12">
          <app-ssc-configuration-edit></app-ssc-configuration-edit>
        </div>
      </div>

      <div class="row form-row" *ngIf="screenType == 2">
        <div class="col-12">
          <app-shared-ref-data></app-shared-ref-data>
        </div>
      </div>
    </form>
  </div>
</div>